export const modulesNamesAndPath = [
  {
    name: "Accounts",
    includePath: "/accounts",
  },
  {
    name: "Sender Id Approval",
    includePath: "/senderIds",
  },
  {
    name: "Gateway and Price",
    includePath: "/gateway-and-price",
  },
  {
    name: "Gateway Name",
    includePath: "/gateway-name",
  },
  {
    name: "Campaign Live Status V2",
    includePath: "/campaign-live-status-v2",
  },
  {
    name: "Campaign Live Status",
    includePath: "/campaign-live-status",
  },
  {
    name: "WhatsApp Accounts",
    includePath: "/whatsapp-accounts",
  }, {
    name: "Admin Analytics",
    includePath: "/admin-analytics",
  },
  {
    name: "Payment Logs",
    includePath: "/payment-logs",
  },
  // {
  //   name: "Leadbot",
  //   includePath: "/lead-bot",
  // },
  // {
  //   name: "Automation",
  //   includePath: "/automation",
  // },
  // {
  //   name: "Import",
  //   includePath: "/import",
  // },
  // {
  //   name: "Export",
  //   includePath: "/export",
  // },
  // {
  //   name: "Profile Settings",
  //   includePath: "/settings/profile",
  // },
  // {
  //   name: "Admin Settings",
  //   includePath: "/settings/account",
  // },
  // {
  //   name: "Billing",
  //   includePath: "/settings/billing/subscription",
  // },
  // {
  //   name: "Wallet",
  //   includePath: "/settings/billing/wallet",
  // },
  // {
  //   name: "Admin",
  //   includePath: "/admin",
  // },
  // {
  //   name: "Learn",
  //   includePath: "/learn/public",
  // },
  // {
  //   name: "Admin",
  //   includePath: "/admin",
  // },
  // {
  //   name: "Campaign - Summary Report",
  //   includePath: "/campaign/reports/summary-report",
  // },
  // {
  //   name: "Campaign - Logs",
  //   includePath: "/campaign/reports/logs",
  // },
  // {
  //   name: "Campaign - Download Report",
  //   includePath: "/campaign/reports/download-report",
  // },
  // {
  //   name: "Campaign - Smart Shortlink",
  //   includePath: "/campaign/smart-short-link",
  // },
  // {
  //   name: "Campaign - Block Contacts",
  //   includePath: "/campaign/block-contact",
  // },
  // {
  //   name: "Campaign",
  //   includePath: "/campaign",
  // },
  // {
  //   name: "Learn",
  //   includePath: "/learn/company",
  // },
  // {
  //   name: "Leads",
  //   includePath: "/leads",
  // },
  // {
  //   name: "Deals",
  //   includePath: "/deal",
  // },
  // {
  //   name: "Home",
  //   includePath: "/activity",
  // },
  // {
  //   name: "Integrations",
  //   includePath: "/settings/integrations",
  // },
];
